export const API_URL = "https://api.gorev.performa.nz/";
//export const API_URL = "http://localhost:3012/";
//export const API_URL = "http://192.168.1.128:3012/";
//export const API_URL = "https://flamba-jeri-toxically.ngrok-free.dev/";

export const PRIORITY = {
    1: "Düşük",
    2: "Orta",
    3: "Yüksek"
};

export const STATUS = {
    1: "Ertelendi",
    2: "Beklemede",
    3: "İşlemde",
    4: "Tamamlandı"
};

export const ADMIN = "552f902f433609e5647aeceef35de035bd8f72470bc1b49d821fb622b4daeb8c";

export const USER = "c14423bb1d8850dfeffa8d9538f79ef74234f11c3ce82f8e82af0ae202f39373";